export const resourceDiscussionsInclude =
  "commenter,commentable,commentable-entities,commentable-insights,attachments,primary-insight," +
  "children,children.commenter,children.attachments,children.commentable-entities,children.commentable-insights," +
  "comment-poll,comment-poll.comment-poll-options,comment-prediction";
